// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cookie_wrapper__roQ-z {
  padding: 50px 100px;
  overflow-x: hidden;
}

.Cookie_content__ccFIe {
  padding: 0 100px;
  width: 55%;
}

.Cookie_p__wzraZ,
.Cookie_pList__Haf4G {
  padding-bottom: 30px;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 400;
  color: #747474;
}

.Cookie_btn__ZEEsD {
  padding: 16px 24px 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  background-color: #47a9f4;
  width: 40%;
  margin-top: 20px;
  color: white;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 16px;
}

.Cookie_btn__ZEEsD:hover {
  cursor: pointer;
  background-color: #3175a8;
}

.Cookie_h1__W\\+Txs {
  font-size: 36px;
  font-family: "Open Sans";
  font-weight: 700;
  color: #090446;
}

.Cookie_h3__7VxbL {
  font-size: 24px;
  font-family: "Open Sans";
  font-weight: 700;
  color: #090446;
}

.Cookie_h4__8EX2U {
  padding-left: 30px;
  font-size: 20px;
  font-family: "Open Sans";
  font-weight: 700;
  color: #090446;
}

.Cookie_li__faF-m {
  list-style: none;
}

.Cookie_check__BsRwL {
  display: flex;
  align-items: center;
}

.Cookie_pList__Haf4G {
  padding-left: 50px;
}

.Cookie_input__SZwEy {
  min-height: 16px;
  min-width: 16px;
}

@media screen and (max-width: 970px) {
  .Cookie_btn__ZEEsD {
    width: 60%;
  }
}

@media screen and (max-width: 770px) {
  .Cookie_h4__8EX2U {
    padding-left: 15px;
  }
  .Cookie_btn__ZEEsD {
    width: 100%;
  }
  .Cookie_pList__Haf4G {
    width: 80%;
    padding-left: 38px;
  }
  .Cookie_list__H2fWK {
    padding-left: 0;
  }
}

@media screen and (max-width: 630px) {
  .Cookie_wrapper__roQ-z {
    padding: 50px 30px;
  }
}

@media screen and (max-width: 450px) {
  .Cookie_content__ccFIe {
    padding: 0 50px;
    width: 75%;
  }
  .Cookie_pList__Haf4G {
    width: 100%;
    padding-left: 38px;
    font-size: 15px;
  }
  .Cookie_wrapper__roQ-z {
    padding: 50px 20px;
  }
}

@media screen and (max-width: 370px) {
  .Cookie_content__ccFIe {
    padding: 0 10px;
    width: 80%;
  }
  .Cookie_pList__Haf4G {
    width: 80%;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Cookie/Cookie.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\n  padding: 50px 100px;\n  overflow-x: hidden;\n}\n\n.content {\n  padding: 0 100px;\n  width: 55%;\n}\n\n.p,\n.pList {\n  padding-bottom: 30px;\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 400;\n  color: #747474;\n}\n\n.btn {\n  padding: 16px 24px 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  background-color: #47a9f4;\n  width: 40%;\n  margin-top: 20px;\n  color: white;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.btn:hover {\n  cursor: pointer;\n  background-color: #3175a8;\n}\n\n.h1 {\n  font-size: 36px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  color: #090446;\n}\n\n.h3 {\n  font-size: 24px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  color: #090446;\n}\n\n.h4 {\n  padding-left: 30px;\n  font-size: 20px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  color: #090446;\n}\n\n.li {\n  list-style: none;\n}\n\n.check {\n  display: flex;\n  align-items: center;\n}\n\n.pList {\n  padding-left: 50px;\n}\n\n.input {\n  min-height: 16px;\n  min-width: 16px;\n}\n\n@media screen and (max-width: 970px) {\n  .btn {\n    width: 60%;\n  }\n}\n\n@media screen and (max-width: 770px) {\n  .h4 {\n    padding-left: 15px;\n  }\n  .btn {\n    width: 100%;\n  }\n  .pList {\n    width: 80%;\n    padding-left: 38px;\n  }\n  .list {\n    padding-left: 0;\n  }\n}\n\n@media screen and (max-width: 630px) {\n  .wrapper {\n    padding: 50px 30px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .content {\n    padding: 0 50px;\n    width: 75%;\n  }\n  .pList {\n    width: 100%;\n    padding-left: 38px;\n    font-size: 15px;\n  }\n  .wrapper {\n    padding: 50px 20px;\n  }\n}\n\n@media screen and (max-width: 370px) {\n  .content {\n    padding: 0 10px;\n    width: 80%;\n  }\n  .pList {\n    width: 80%;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Cookie_wrapper__roQ-z`,
	"content": `Cookie_content__ccFIe`,
	"p": `Cookie_p__wzraZ`,
	"pList": `Cookie_pList__Haf4G`,
	"btn": `Cookie_btn__ZEEsD`,
	"h1": `Cookie_h1__W+Txs`,
	"h3": `Cookie_h3__7VxbL`,
	"h4": `Cookie_h4__8EX2U`,
	"li": `Cookie_li__faF-m`,
	"check": `Cookie_check__BsRwL`,
	"input": `Cookie_input__SZwEy`,
	"list": `Cookie_list__H2fWK`
};
export default ___CSS_LOADER_EXPORT___;
